/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* istanbul ignore file */
import * as Survey from "survey-react";
import { format } from "date-fns";
import { GrantPayload } from "../../config/forms";

export function transformMaraeBookingData(
    survey: Survey.SurveyModel
): GrantPayload {
    const surveyData = survey.data;
    const {
        addressfinder,
        adults,
        arrivalDate,
        arrivalTime,
        bookingPurpose,
        contactName,
        departTime,
        departDate,
        email,
        facilities,
        kaumatua,
        message: sourceMessage,
        organisation,
        phone,
        services,
        tamariki,
    } = surveyData;
    const {
        /* eslint-disable-next-line @typescript-eslint/naming-convention */
        address_line_1,
        /* eslint-disable-next-line @typescript-eslint/naming-convention */
        address_line_2,
        suburb,
        city,
        postcode,
        country,
    } = addressfinder;
    const addressLines = [
        address_line_1,
        address_line_2,
        suburb,
        city,
        postcode,
        country,
    ];
    const address = `   ${addressLines.filter((rec) => rec).join("\n   ")}`;
    const tenant = process.env.TAH_TENANT;

    const guests = `
        Kaumatua ${kaumatua || 0}
        Adults ${adults || 0}
        Tamariki ${tamariki || 0}`;
    const message = `Organisation: ${organisation || ""}
Name: ${contactName}
Phone: ${phone}
Address:
${address}
Purpose of Booking: ${bookingPurpose}
Arrival Date: ${format(new Date(arrivalDate), "dd/MMM/yyyy")}
Arrival Time: ${arrivalTime}
Depart Date: ${format(new Date(departDate), "dd/MMM/yyyy")}
Depart Time: ${departTime}
Number of Guests: ${guests}
Required Facilities: ${facilities}
Required Services: ${services}
Message: ${sourceMessage || ""}`;

    return {
        data: {
            email: {
                name: contactName,
                email,
                message,
                subject: "Ngāti Kuia Marae Booking",
                emailTo: process.env.MARAE_EMAIL,
            },
        },
        recaptcha: null,
        tenant,
    };
}
